import React, { useState } from 'react'
import { CONFIG } from './config'
import styled from 'styled-components'
import { Waypoint } from 'react-waypoint'

/**
 * Component for Scrollytelling
 *
 * Elements for front layer
 * @prop {React.ReactChild[]} front
 *
 * Function returning background layer element
 * index = current visible front layer element
 * @prop {( index:Number )=> React.ReactChild } background
 *
 * gap between the front layer elements as viewport height
 * @prop { Number } distance
 *
 * space after last front element as viewport height
 * @prop { Number } endSpace
 *
 * @returns { React.Element } React Component
 */

export const Scroller = ({
  front,
  back,
  defaultDistance = CONFIG.default.spacerHeight,
  className,
  currentIndex,
  setCurrentIndex,
}: {
  front: JSX.Element[]
  back: (e: number, o: { [key: string]: any }) => JSX.Element
  defaultDistance?: number
  className?: string
  currentIndex: number
  setCurrentIndex: (e: number) => void
}) => {
  return (
    <StyledScroller className={'Scroller ' + className} id='scroller'>
      <div className='back' id='back'>
        {back(currentIndex, front[currentIndex])}
      </div>
      <div className='front'>
        {front.map((element, i) => {
          let d = element.props.distance || defaultDistance || 100
          return (
            <React.Fragment key={'Front_' + i}>
              <Waypoint
                scrollableAncestor={window}
                onEnter={(e) => {
                  setCurrentIndex(i)
                }}
                onLeave={(e) => {
                  let newindex = i + (e.currentPosition === 'below' ? -1 : 1)
                  if (newindex < 0) {
                    newindex = 0
                  }
                  setCurrentIndex(newindex)
                }}
              >
                <FrontElementWrapper>{element}</FrontElementWrapper>
              </Waypoint>
              <Spacer style={{ minHeight: d + 'px' }} />
            </React.Fragment>
          )
        })}
      </div>
    </StyledScroller>
  )
}

const Spacer = styled.div`
  pointer-events: none;
`
const FrontElementWrapper = styled.div`
  pointer-events: auto;
  max-width: 100%;
`
const StyledScroller = styled.div`
  position: relative;
  display: block;
  width: 100%;
  .back {
    z-index: 1;
    position: sticky;
    top: 0;
    height: 100vh;
  }

  .front {
    position: relative;
    pointer-events: none;
    z-index: 20;
    margin-left: auto;
    margin-right: auto;
    max-width: 100%;
  }
`
